/**
 * Created by Administrator on 2017/8/26.
 */
import axios from 'axios';
import {appidConfigCache, tokenCache} from "./cache"
import {
  debug, getAID,
  getApiUrl,
  getClientInfo,
  getClientToken,
  getParamsFromUrl, isAndroidBrower,
  isBrower, isDevelopment, isIphoneBrower,
  makeRandom,
  makeToken
} from "./util"
import {baseParams} from "./config";
import {_custom, monitor} from "./monitor";
import {decryptByECB} from "@/lib/cryptojs";
import {makeHeaderSign} from "@/utils/makeHeaderSign";
import * as R from 'ramda'

let base = baseParams;

export default function (service, options, headers = {}) {

  base.random = makeRandom(4);
  //console.log(2);
  const {query} = getParamsFromUrl(location.href);
  const appidConfig = appidConfigCache.get();
  let obj = {...base, service, ...options};

  //console.log(3333)

  if (query.channel) {
    obj.channel = query.channel;
  } else if (appidConfig && appidConfig.channel) {
    obj.channel = appidConfig.channel
  }


  //额外参数
  obj._host = location.host;
  obj._pv = encodeURIComponent(location.hash);
  obj._device = getClientInfo(window.navigator.userAgent);
  obj._aid = getAID();

  //console.log(3333)

  if (!obj.token)
    obj.token = getClientToken().token;
  if (obj.needToken === false || obj.token === '') {
    delete obj.token;
  }
  let sign = makeHeaderSign(obj);
  let config = {
    headers: {
      ...headers,
      "sign": sign,
      "Content-Type": "application/json",
    },
  }

  //console.log(3333)

  let url = getApiUrl();
  debug("==>" + service, obj);
  // _custom(obj);
  monitor._time(service, 'start');
  let time;

  //console.log(2222)

  return axios.post(url, obj, config)
    .then((res) => {
      time = monitor._time(service, 'end');
      // bus.$emit("loading", {status: 'stop'});
      if (res.status == 200) {
        if (typeof res.data === 'string') {
          let temp;
          temp = handlerText(res.data);
          //Log('首次尝试', temp);
          if (!temp) temp = handlerDeCryptoText(res.data);
          //Log('再次尝试', temp);
          if (!temp)
            temp = {code: -1, msg: '解密失败'};
          res.data = temp;
        }
        debug(`<==${obj.service}`, R.clone(res.data));
        const {code = '', msg} = res.data;
        /*if (code === "00000009") {
          bus.$emit('msg', '登录过期，请重新登录');
          location.replace('#/account/prelogin?callback=' + encodeURIComponent(location.hash.slice(1)));
        }*/
        try {
          monitor.api(service, code == '0', time, code, JSON.stringify(options) + ":" + JSON.stringify(zipResponseData(res.data)));
        } catch (e) {

        }
        return res.data;
      } else {
        monitor.api(service, false, time, res.status, 'error')
        return res;
      }
    });
}


export function handlerText(text) {
  try {
    return JSON.parse(text);
  } catch (e) {
    return false;
  }
}

export function handlerDeCryptoText(text) {
  try {
    text = decryptByECB(decodeURIComponent(text));
    return JSON.parse(text);
  } catch (e) {
    return false;
  }
}


function zipResponseData(data) {
  let data2 = R.clone(data);
  let ans = Array.isArray(data2) ? [] : typeof data2 === 'object' ? {} : data2;
  if (Array.isArray(data2)) {
    for (let i = 0; i < data2.length; i++) {
      ans[i] = zipResponseData(data2[i]);
    }
  } else if (typeof data2 === 'object') {
    for (let key in data2) {
      ans[key] = zipResponseData(data2[key]);
    }
  }
  if (typeof ans === 'string' && ans.length > 10) {
    ans = ans.substring(0, 10) + '...';
  }
  return ans;
}



// WEBPACK FOOTER //
// ./src/lib/api.js